module.exports = __webpack_public_path__ + "img/kplay_esport.bde308b2.jpg";